
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

export const useFormLogger = (form: UseFormReturn<any>) => {
  // Log when form values change
  useEffect(() => {
    const subscription = form.watch((value, info) => {
      if (info && info.name) {
        console.log(`[useFormLogger] Field changed: ${info.name}, type: ${info.type}, value:`, value[info.name]);
      }
    });
    
    return () => subscription?.unsubscribe();
  }, [form]);

  return {
    logFormState: () => {
      console.log('[useFormLogger] Form state:', {
        isDirty: form.formState.isDirty,
        dirtyFields: form.formState.dirtyFields,
        isValid: form.formState.isValid,
        errors: form.formState.errors,
      });
    }
  };
};
